import { render, staticRenderFns } from "./search-results.vue?vue&type=template&id=4e11b63b"
import script from "./search-results.vue?vue&type=script&lang=js"
export * from "./search-results.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports